import {APIClient, useAuthContext, useClient} from '../context/auth-context';
import {useMutation} from 'react-query';
import {toast} from 'react-toastify';

export type AdminRequestBody = {
  email: string;
  id: string;
  name: string;
};

export function save(
  client: APIClient,
  companyId: string,
  data: AdminRequestBody,
) {
  return client.put(`user/company/${companyId}/xeuser`, {
    data,
  });
}

export function confirm(client: APIClient, companyId: string) {
  return client.put(`user/company/${companyId}/xeuser/confirm`);
}

export function useSaveMutate(actions: any) {
  const client = useClient();
  const {companyId} = useAuthContext();
  return useMutation(
    (data: AdminRequestBody) => save(client, companyId, data),
    {
      ...actions,
      onError: (error: {code: number; message: string}) => {
        if (error.code !== 500 && error.message !== 'NotEnablePY') {
          toast.error(error.message || '儲存失敗', {
            hideProgressBar: true,
            position: 'top-center',
            autoClose: false
          });
        }
      },
    },
  );
}

export function useConfirmMutate(actions: any) {
  const client = useClient();
  const {companyId} = useAuthContext();
  return useMutation(
    (data: AdminRequestBody) =>
      save(client, companyId, data).then(() => confirm(client, companyId)),
    {
      ...actions,
      onError: (error: {code: number; message: string}) => {
        if (error.code !== 500 && error.message !== 'NotEnablePY') {
          toast.error(error.message || '儲存失敗', {
            hideProgressBar: true,
            position: 'top-center',
            autoClose: false
          });
        }
      },
    },
  );
}
